import { SplashLoader } from '~/domains/common/components/SplashLoader/SplashLoader';
import NotFoundScreen from '~/domains/common/components/NotFoundScreen/NotFoundScreen';
import UnknownErrorScreen from '~/domains/common/components/UnknownErrorScreen/UnknownErrorScreen';
import { PageLayout } from '~/domains/common/app/PageLayout';
import { isApiError } from '~/domains/services/utils/isApiError';
import { ContestChatModalContextProvider } from '../ContestChat/ContestChatModals/ContestChatModalContext';
import ContestChatModals from '../ContestChat/ContestChatModals/ContestChatModals';
import { ContestChatProvider } from '../ContestChat/ContestChatContext';
import { PusherContextProvider } from '~/domains/pusher/PusherContext';
import { useTreatment } from '~/domains/common/hooks/useTreatment';
import { FEATURE } from '~/common/enums/feature.enum';

import { useContestContext } from '../../context/ContestContext/ContestContext';

type GamecenterPageLoadingStatesHandlerProps = {
  children: React.ReactNode;
};

function GamecenterPageLoadingStatesHandler({ children }: GamecenterPageLoadingStatesHandlerProps) {
  const { isContestLoading, contestError, isNotFound } = useContestContext();

  // Check if Pusher is enabled via feature flag
  const { isReady, treatment } = useTreatment(FEATURE.CONFIG_PUSHER_ENABLED_ENDPOINTS);
  const isPusherFlagEnabled = isReady && treatment?.treatment === 'on';

  if (isContestLoading) {
    return <SplashLoader />;
  }

  if (isNotFound) {
    return (
      <PageLayout>
        <UnknownErrorScreen statusCode={404} />
      </PageLayout>
    );
  }

  if (contestError && isApiError(contestError)) {
    return (
      <PageLayout>
        <UnknownErrorScreen statusCode={contestError.response?.status} />
      </PageLayout>
    );
  }

  return (
    <ContestChatModalContextProvider>
      <PusherContextProvider enabled={isPusherFlagEnabled}>
        <ContestChatProvider>
          {children}
          <ContestChatModals />
        </ContestChatProvider>
      </PusherContextProvider>
    </ContestChatModalContextProvider>
  );
}

export default GamecenterPageLoadingStatesHandler;
